import React from 'react';
import styles from './styles.scss';

export default class Photo extends React.Component {
  render() {
    const {photo, margin, direction, top, left} = this.props;

    const style = {
      margin,
      width: Math.round(photo.width),
      height: Math.round(photo.height),
    };

    if (direction === 'column') {
      style.position = 'absolute';
      style.left = Math.round(left);
      style.top = Math.round(top);
    }

    let width = Math.round(photo.width);
    let height = Math.round((width / photo.srcWidth) * photo.srcHeight);

    if (height > photo.height) {
      height = Math.round(photo.height);
      width = Math.round((height / photo.srcHeight) * photo.srcWidth);
    }

    return (
      <div className={styles.photoWrapper} style={{...style, ...photo.style}}>
        <img src={photo.src} width={width} height={height} draggable="false" />
        <a href="#" title="Remove photo" className={styles.removeButton} onClick={this.handleClick}>
          <svg viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z"
            />
          </svg>
        </a>
      </div>
    );
  }

  handleClick = event => {
    event.preventDefault();
    event.stopPropagation();

    this.props.onClick(event, {
      photo: this.props.photo,
      index: this.props.photo.key,
    });
  };
}
